import { type } from '@packages/themes/tokens';
import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/v4/tss-react';

const TOGGLE_RADIUS_PX = 32;
const TOGGLE_OPTION_RADIUS_PX = 48;
const TOGGLE_INSET_PX = 4;

const useStyles = makeStyles({ name: 'SunrunMembership' })(
  ({ palette, spacing }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(-1),
      padding: spacing(0),
      borderRadius: pxToRem(8),
      border: `${pxToRem(1)} solid ${palette.semantic.input.borderDefault}`,
    },
    priceRow: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: spacing(-1),
    },
    prices: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      whiteSpace: 'nowrap',
    },
    originalPrice: {
      ...type['16_regular'],
    },
    toggle: {
      display: 'flex',
      gap: pxToRem(TOGGLE_INSET_PX),
      padding: pxToRem(TOGGLE_INSET_PX),
      borderRadius: pxToRem(TOGGLE_RADIUS_PX),
      border: `${pxToRem(1)} solid ${palette.semantic.border.secondary}`,
      backgroundColor: palette.semantic.bg.layer1,
    },
    toggleOption: {
      flex: 1,
      padding: `${pxToRem(TOGGLE_INSET_PX)} ${spacing(0)}`,
      border: 'none',
      borderRadius: pxToRem(TOGGLE_OPTION_RADIUS_PX),
      backgroundColor: 'transparent',
      color: palette.semantic.text.primary,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      '&:hover:not([aria-pressed="true"])': {
        backgroundColor: palette.semantic.bg.categoryActive,
      },
    },
    toggleOptionSelected: {
      backgroundColor: palette.semantic.button.primary,
      color: palette.semantic.text.inverse,
    },
  })
);

export default useStyles;
